import { ChevronRight } from "lucide-react";
import Text from "../Text/Text";
import styles from "./Breadcrumb.css";

interface BreadcrumbProps {
  /** Outermost first; the last entry is the current place and reads white. */
  items: string[];
  ariaLabel?: string;
}

const Breadcrumb = ({ items, ariaLabel = "Breadcrumb" }: BreadcrumbProps) => {
  if (items.length === 0) return null;

  return (
    <nav aria-label={ariaLabel}>
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isCurrent = index === items.length - 1;

          return (
            <li
              key={`${index}-${item}`}
              className={styles.item}
              aria-current={isCurrent ? "page" : undefined}
            >
              {index > 0 && (
                <ChevronRight
                  size={16}
                  className={styles.separator}
                  aria-hidden
                />
              )}
              <Text
                variant="body-small"
                color={isCurrent ? "neutral-0" : "neutral-100"}
              >
                {item}
              </Text>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
